export default [
    {
        path: '/student',
        component: () => import('@/views/student')
    },
    {
        path: '/student/add',
        component: () => import('@/views/user/add')
    },
    {
        path: '/student/:id',
        props: (route) => ({
            id:  Number(route.params.id)
        }),
        component: () => import('@/views/user/detail'),
        meta:{
            name:'/student'
        }
    },
    {
        path: '/student/:id/learning-performance/:userNo',
        props: (route) => ({
            id:  Number(route.params.id),
            userNo:  route.params.userNo
        }),
        component: () => import('@/views/student/learning-performance'),
        meta:{
            name:'/learning-performance'
        }
    },
    {
        path: '/student/:id/edit',
        props: (route) => ({
            id:  Number(route.params.id)
        }),
        component: () => import('@/views/user/edit'),
        meta:{
            name:'/studentEdit'
        }
    },
    {
        path: '/answer-record',
        component: () => import('@/views/student/answerRecord')
    }
    // ,{
    //     path: '/answer-record-detail',
    //     component: () => import('@/views/student/examinationAnswerResult')
    // }
]